<template>

  <div class="box-balance-resume">
    <div class="container">
      <div class="simulation-investment-resume -centered-info">
        <div class="row row-responsive">
          <div class="column column-sm-33">
            <span class="title">Saldo disponible</span>
            <span class="value">{{ formatCurrency($store.getters.getUserBalance.balance) }}</span>
          </div>
          <div class="column column-sm-33">
            <span class="title">Total invertido activo:</span>
            <span class="value">{{ formatCurrency($store.getters.getUserBalance.total_active_investment) }}</span>
          </div>
          <div class="column column-sm-33">
            <span class="title">Total incobrable:</span>
            <span class="value">{{ formatCurrency($store.getters.getUserBalance.total_uncollectible_investment) }}</span>
          </div>
          <div class="column column-sm-33">
            <span class="title">Tasa promedio:</span>
            <span class="value">{{ formatPercentage($store.getters.getUserBalance.average_rate) }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>

import mixins from '@/mixins/index'

export default {
  name: 'DashboardBalanceResume',
  mixins: [mixins],
  created: function () {
    this.getBalance()
  }
}

</script>

<style lang="scss" scoped>

.box-balance-resume {}

.simulation-investment-resume {
  margin: 2rem 0;
  padding: 0 2rem;
  border: 1px solid #ccc;
  border-radius: 6px;

  &.-background-dark {
    background-color: $midnight-blue;
    color: $white;
    border-radius: 6px;
  }

  .column {
    padding: 1rem 0 0;

    &:last-of-type {
      padding-bottom: 1rem;
    }
  }

  .title,
  .value {
    display: block;
  }
  .title {
    margin-bottom: .5rem;
    padding-bottom: .5rem;
    color: $midnight-blue;
    font-size: .9em;
    border-bottom: 1px solid #ccc;
  }
  .value {
    font-weight: bold;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/DashboardBalanceResume.vue